const Paths = {
  availablePaths: [],
  add(paths) {
    Object.assign(this, paths);
    this.availablePaths = Object.keys(paths);
  },
  build(path, values = {}) {
    if (path === undefined) {
      const availablePathsDescription = this.availablePaths.length
        ? `Available paths are: ${this.availablePaths.join(", ")}`
        : "No paths have been declared using `paths.add({...})`.";
      throw new Error(
        `The path specified is undefined and can not be built. Does the path you're trying to build exist in the paths object? ${availablePathsDescription}`
      );
    }

    return Object.keys(values).reduce(
      (templatePath, valueKey) =>
        templatePath?.replace(`:${valueKey}:`, encodeURIComponent(values[valueKey])),
      path
    );
  },
  // this returns the path prefixed with 'path:' for fetch-mock-jest
  buildTesting(path, values) {
    return `path:${Paths.build(path, values)}`;
  }
};

export default Paths;
